import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SubmittalClientNotesEffects } from 'src/app/root-store/account-managers-submittals-store/effects/submittals-clientnotes.effects';
import { submittalClientNotesReducer } from 'src/app/root-store/account-managers-submittals-store/reducers/submittals-clientnotes.reducers';
import { submittalClientNotesFeatureKey } from 'src/app/root-store/account-managers-submittals-store/selectors/submittals-clientnotes.selectors';

export const provideAccountManagersSubmittalsStore = (): EnvironmentProviders[] => [
    provideState(submittalClientNotesFeatureKey, submittalClientNotesReducer),
    provideEffects([SubmittalClientNotesEffects])
];
